import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@styles/index.css';
import { optimizeFontLoading, logPerformanceMetrics } from '@utils/optimization';

// Initialize performance optimizations
if (import.meta.env.PROD) {
  // Optimize font loading
  optimizeFontLoading();
}

// Log performance metrics in development
if (import.meta.env.DEV) {
  // Log metrics after page load
  window.addEventListener('load', () => {
    setTimeout(() => {
      logPerformanceMetrics();
    }, 1000);
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
